export default __webpack_public_path__ + "static/media/bng_title.51ff22fe.gif";